/** 等待下一幀 */
export function waitNextTick(
  use: 'nextTick' | 'setTimeOut' = 'setTimeOut'
): Promise<void> {
  return new Promise((resolve) => {
    if (use === 'setTimeOut') {
      setTimeout(resolve)
    } else {
      nextTick(resolve)
    }
  })
}
